import useCompanyType from "../../../hooks/useCompanyType";
import { Select } from "../../ui/Select"
import React from "react"

export const SelectCompanyType = React.memo(({label, name, value, country, onChange, required, disabled, isReport}) => {

    const companyTypes = useCompanyType(country);

    return (
        <div className="form-group">
            <Select
                label={label}
                name={name}
                isReport={isReport}
                required={required}
                value={value}
                disabled={disabled}
                onChange={onChange}
                options={companyTypes.map((value)=>({ value: value.CompanyType, display_value: value.CompanyType }))}
            />
        </div>
    )
})